import { render, staticRenderFns } from "./UserResetPasswordMethodSelection.vue?vue&type=template&id=66b3a58e"
import script from "./UserResetPasswordMethodSelection.vue?vue&type=script&lang=ts"
export * from "./UserResetPasswordMethodSelection.vue?vue&type=script&lang=ts"
import style0 from "./UserResetPasswordMethodSelection.vue?vue&type=style&index=0&id=66b3a58e&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports